import { Avatar } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { useSelector } from 'react-redux';
import css from './styles.module.scss';
import { selectUserData } from '~/features/dashboard/store/selectors';

interface UserBarProps {}

export const UserBar: React.FC<UserBarProps> = () => {
    const user = useSelector(selectUserData);

    return (
        <div className={css.module}>
            <Avatar alt={user?.name} src={user?.image} className={'avatar'} variant={'square'} />
            <Typography className={'name'}>{user?.name}</Typography>
        </div>
    );
};
